import React from "react";
import StatusBorder from "../Status/StatusBorder";
import CommonAvatar from "./CommonAvatar";
import ProfileTextStack from "./ProfileTextStack";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

const cn = (...inputs) => twMerge(clsx(inputs));

const ProspectProfileRow = ({
  avatarUrl,
  name,
  email,
  number,
  onClick,
  id,
  className,
  avatarSize = "md",
  grayborderColor = false,
}) => {
  return (
    <div
      className={cn("flex min-w-0 w-full items-center gap-2", className)}
      onClick={onClick}
      key={id}
    >
      <StatusBorder number={number} grayborderColor={grayborderColor}>
        <CommonAvatar
          imageUrl={avatarUrl}
          name={name}
          className="shrink-0 rounded-full object-cover"
          size={avatarSize}
        />
      </StatusBorder>
      <ProfileTextStack primary={name} secondary={email} />
    </div>
  );
};

export default ProspectProfileRow;
